export const modal = {
  modifyTitle: "EDITAR RESERVA",
  createTitle: "CRIAR RESERVA",
  modifyAction: "Editar reserva",
  createAction: "Criar reserva",
  processing: "Processando reserva...",

  selectRoomType: "Selecione o tipo de quarto",
  selectAccommodation: "Selecione uma acomodação",

  quantity: "Quantidade",
  arrival: "Chegada",
  departure: "Saída",
  guestName: "Nome do hóspede",
  email: "E-mail",
  phone: "Telefone",
  guestsNumber: "Número de hóspedes",
  price: "Preço",
  cancel: "Cancelar",

  noTemplateSummary: "Nenhum modelo ativo",
  noTemplateDetail: "Nenhum modelo disponível",

  limitReachedSummary: "Limite atingido",
  limitPromotionDetail: "Você não pode adicionar mais de 1 promoção",
  limitTaxDetail: "Você não pode adicionar mais de 1 imposto",

  validations: {
    fillRequired: "Preencha todos os campos obrigatórios.",
    phoneMin: "O número de telefone deve ter pelo menos 5 dígitos.",
    selectDates: "Selecione as datas de chegada e saída.",
    guestsMin: "O número de hóspedes deve ser pelo menos 1.",
    priceNegative: "O preço não pode ser negativo.",
  },
};

export default modal;
